<div class="flex flex-row justify-between mt-4 min-h-[40px]">
	<p class="text-[#1C252E] font-medium text-base leading-5 m-0">
		{{ 'ORGANIZATION.BRANCH.LOCATION' | translate }}
		<span *ngIf="!branchInformationData?.address" class="text-[#7e2eb3]"
			>*</span
		>
	</p>
	<div
		*ngIf="!editMode"
		class="flex gap-1 ltr:mr-6 rtl:ml-6 hover:cursor-pointer"
	>
		<img class="w-5 max-h-5" src="assets/images/edit-blue.svg" alt="" />
		<p (click)="onEditClicked()" class="text-[#009EF7]">
			{{ 'ACTIONS.EDIT' | translate }}
		</p>
	</div>
</div>

<div class="{{ editMode ? 'z-40 relative' : '' }}">
	<div
		class="flex flex-col custom-shadow p-24px gap-[14px] rounded-12px bg-off-white lg:w-[776px]"
	>
		<form [formGroup]="locationForm" (keydown.enter)="$event.preventDefault()">
			<div class="bg-white rounded-[50px]"></div>

			<div class="relative">
				<google-map
					#map
					height="400"
					width="100%"
					[center]="center"
					[zoom]="zoom"
				>
					<map-marker
						[position]="position"
						[options]="
							editMode && !branchInformationData?.hasAppointments
								? { draggable: true }
								: { draggable: false }
						"
						(mapDragend)="onMarkerDropped($event)"
					></map-marker>
				</google-map>
				<div class="map">
					<mat-form-field
						appearance="outline"
						class="w-[97%] map ltr:custom-left rtl:custom-right absolute top-[24px] md:ms-[12px] ms-[5px]"
						[style]="{ display: editMode ? 'block' : 'none' }"
					>
						<div>
							<img
								class="absolute ltr:left-[6px] rtl:right-0 inline-block top-[12px] pr-12px"
								src="./assets/images/search-normal.svg"
								alt=""
							/>
						</div>
						<input
							class="ml-8 rtl:mr-11 rtl:ml-11 w-[96%]"
							#inputField
							formControlName="locationSearch"
							matInput
							[value]="this.branchInformationData?.address"
							placeholder="{{
								'ORGANIZATION.BRANCH.LABELS.SEARCH' | translate
							}}"
						/>
						<mat-error>
							<validation-message
								[controller]="getController('locationSearch')"
								controller_name="locationSearch"
								pattern_Message=""
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
					<mat-form-field
						appearance="outline"
						class="w-[97%] map ltr:custom-left rtl:custom-right absolute top-[24px] md:ms-[12px] ms-[5px]"
						[style]="{ display: editMode ? 'none' : 'block' }"
					>
						<input
							class="w-[96%]"
							#inputField
							disabled="true"
							matInput
							[value]="this.branchInformationData?.address"
							placeholder="{{
								'ORGANIZATION.BRANCH.LABELS.SEARCH' | translate
							}}"
						/>
						<mat-error>
							<validation-message
								[controller]="getController('locationSearch')"
								controller_name="locationSearch"
								pattern_Message=""
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<small class="text-red-error" *ngIf="errorChooseLocation">
				{{ 'ORGANIZATION.BRANCH.LOCATION_COUTRY_ERROR' | translate }}
			</small>
			<p
				class="mt-24px mb-0 ltr:ml-[17px] rtl:mr-[17px] ltr:font-DIN-Bold font-bold rtl:font-medium text-font-16 text-dark-grey"
			>
				{{ 'ORGANIZATION.BRANCH.SHORT_ADDRESS' | translate }}
				<span *ngIf="editMode">{{
					'ORGANIZATION.BRANCH.OPTIONAL' | translate
				}}</span>
			</p>

			<mat-form-field *ngIf="editMode" class="w-full mt-4" appearance="outline">
				<mat-label>{{
					'ORGANIZATION.BRANCH.ADDRESS_NAME_EN' | translate
				}}</mat-label>
				<input
					type="text"
					formControlName="shortAddressEn"
					matInput
					placeholder="{{ 'ORGANIZATION.BRANCH.ADDRESS_NAME_EN' | translate }}"
					maxlength="100"
					minlength="2"
					[ngClass]="!editMode ? 'text-[#6E7191]' : 'text-[#4E4B66]'"
				/>
				<img
					*ngIf="getController('shortAddressEn')?.value && editMode"
					(click)="getController('shortAddressEn').setValue('')"
					class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
					src="./assets/images/close-square.svg"
					alt=""
				/>

				<mat-error>
					<validation-message
						[controller]="getController('shortAddressEn')"
						controller_name="shortAddressEn"
						pattern_Message=""
					>
					</validation-message>
				</mat-error>
			</mat-form-field>
			<div
				*ngIf="!editMode"
				class="w-full max-h-[73px] p-[17px] border-solid border-b-2"
			>
				<p class="mb-0 pb-0 text-[#6E7191]">
					{{ 'ORGANIZATION.BRANCH.ADDRESS_NAME_EN' | translate }}
				</p>
				<p class="viewMode">
					{{ this.branchInformationData?.shortAddressEn }}
				</p>
			</div>
			<mat-form-field *ngIf="editMode" class="w-full mt-1" appearance="outline">
				<mat-label>{{
					'ORGANIZATION.BRANCH.ADDRESS_NAME_AR' | translate
				}}</mat-label>
				<input
					type="text"
					formControlName="shortAddressAr"
					matInput
					placeholder="{{ 'ORGANIZATION.BRANCH.ADDRESS_NAME_AR' | translate }}"
					maxlength="100"
					minlength="2"
					[ngClass]="!editMode ? 'text-[#6E7191]' : 'text-[#4E4B66]'"
				/>
				<!-- <img
					*ngIf="getController('shortAddressAr')?.value && editMode"
					(click)="getController('shortAddressAr').setValue('')"
					class="cursor-pointer absolute ltr:right-0 rtl:left-0 inline-block top-[9px]"
					src="./assets/images/close-square.svg"
					alt=""
				/> -->

				<mat-error>
					<validation-message
						[controller]="getController('shortAddressAr')"
						controller_name="shortAddressAr"
						pattern_Message=""
					>
					</validation-message>
				</mat-error>
			</mat-form-field>
			<p *ngIf="editMode">
				{{ 'ORGANIZATION.BRANCH.LOCATION_HINT' | translate }}
			</p>

			<div
				*ngIf="!editMode"
				class="w-full max-h-[73px] p-[17px] border-solid border-b-2"
			>
				<p class="mb-0 pb-0 text-[#6E7191]">
					{{ 'ORGANIZATION.BRANCH.ADDRESS_NAME_AR' | translate }}
				</p>
				<p class="viewMode">
					{{ this.branchInformationData?.shortAddressAr }}
				</p>
			</div>
			<p
				class="text-font-12 text-medium-gray"
				*ngIf="branchInformationData?.hasAppointments && editMode"
			>
				{{ 'ORGANIZATION.BRANCH.CANT_CHANGE_LOCATION' | translate }}
			</p>
			<div class="flex justify-end gap-3 mt-5">
				<!-- cancel button  -->
				<button
					*ngIf="editMode"
					(click)="onCancelClicked()"
					class="border border-solid border-[#D9DBE9] text-dark-grey hover:bg-gradient hover:text-off-white mx-2"
					mat-button
				>
					{{ 'ACTIONS.CANCEL' | translate }}
				</button>
				<!-- submit button  -->
				<button
					*ngIf="editMode"
					[disabled]="locationForm.invalid || !position || errorChooseLocation"
					(click)="update()"
					class="bg-gradient text-white rounded"
					mat-button
				>
					{{ 'ACTIONS.SAVE' | translate }}
				</button>
			</div>
		</form>
	</div>
</div>
<div
	*ngIf="editMode"
	class="overlay bg-black opacity-30 fixed top-0 left-0 w-screen h-screen z-30"
></div>
